import { format_time_Number, roundUsageWith5Digits } from '../../util/NumberFormatter';
import { getFullCountryNames } from '../../util/UtilFunctions';
import { showOverflowTooltip, showAlwaysOverflowTooltip } from '../common/OverflowTooltip/OverflowTooltip';
import { TRAFFIC } from './../../constants/general';
import { getHeatMapColors } from './../widgets/world/Common/tools/ValueColorizer';

const hiddenColumn = {
   text: 'hiddenKey',
   dataField: 'hiddenKey',
   hidden: 'true',
};

const defaultStyle = { verticalAlign: 'middle', textAlign: 'center' };

export function getUsageColumnsSettings(desc, columnNames, categoryData, options = { usageSwitch: TRAFFIC }) {
   const { usageSwitch } = options;
   const orgaColumnRequired = isOrgaColumnRequired(categoryData);
   const roundFn = usageSwitch === TRAFFIC ? roundUsageWith5Digits : format_time_Number;
   const formatter = (cell, row) => {
      if (cell === '-') return cell;
      const rounded = roundFn(cell);
      return rounded === 0 ? '< 0.001' : rounded;
   };

   const columns = [
      hiddenColumn,
      {
         text: desc,
         dataField: 'key',
         sort: true,
         style: defaultStyle,
         headerAlign: 'center',
         formatter: (cell) => showOverflowTooltip(getFullCountryNames(cell)),
      },
      {
         text: columnNames[0],
         dataField: 'value',
         sort: true,
         style: defaultStyle,
         headerAlign: 'center',
         formatter,
      },
   ];

   if (orgaColumnRequired) {
      columns.splice(2, 0, {
         text: 'Organisation',
         dataField: 'orga',
         sort: true,
         style: defaultStyle,
         headerAlign: 'center',
         formatter: showOverflowTooltip,
         headerFormatter: (col) => showOverflowTooltip(col.text),
      });
   }

   return columns;
}

export function getDefaultColumnsSettings(
   desc,
   columnNames,
   categoryData,
   options = {
      dataFieldNames: 'value',
      formatters: undefined,
      cellStyles: undefined,
   },
) {
   const { dataFieldNames, formatters, cellStyles } = options;
   const orgaColumnRequired = isOrgaColumnRequired(categoryData);

   const columns = [
      hiddenColumn,
      {
         text: desc,
         dataField: 'key',
         sort: true,
         style: defaultStyle,
         headerAlign: 'center',
         formatter: (cell) => showOverflowTooltip(getFullCountryNames(cell)),
      },
   ];

   if (orgaColumnRequired) {
      columns.push({
         text: 'Organisation',
         dataField: 'orga',
         sort: true,
         style: defaultStyle,
         headerAlign: 'center',
         formatter: showOverflowTooltip,
         headerFormatter: (col) => showAlwaysOverflowTooltip(col.text),
      });
   }

   for (let index = 0; index < columnNames.length; index++) {
      columns.push({
         text: columnNames[index],
         dataField: dataFieldNames[index],
         sort: true,
         style:
            cellStyles === undefined
               ? defaultStyle
               : cellStyles[index] === undefined
               ? defaultStyle
               : cellStyles[index],
         headerAlign: 'center',
         formatter: formatters === undefined ? undefined : (cell) => showOverflowTooltip(formatters[index](cell)),
         headerFormatter: (col) => showAlwaysOverflowTooltip(col.text),
      });
   }

   return columns;
}

export function getAbrWorldMapColumnsSettings(
   desc,
   columnNames,
   categoryData,
   options = { formatters: (cell) => cell },
) {
   const { formatters } = options;

   const orgaColumnRequired = isOrgaColumnRequired(categoryData);

   const columns = [
      hiddenColumn,
      {
         text: desc,
         dataField: 'key',
         sort: true,
         style: defaultStyle,
         headerAlign: 'center',
         formatter: showOverflowTooltip,
         headerFormatter: (col) => showOverflowTooltip(col.text),
      },
   ];

   if (orgaColumnRequired) {
      columns.push({
         text: 'Organisation',
         dataField: 'orga',
         sort: true,
         style: defaultStyle,
         headerAlign: 'center',
         formatter: showOverflowTooltip,
         headerFormatter: (col) => showOverflowTooltip(col.text),
      });
   }

   if (categoryData && categoryData.length > 0) {
      const firstRow = categoryData[0];
      const keys = Object.keys(firstRow);
      const profileNames = keys.filter((profile) => profile !== 'key' && profile !== 'orga');

      const values = profileNames.map((profileName) => firstRow[profileName]);
      const maxValue = Math.max(...Object.values(values));

      profileNames.forEach((profileName) => {
         columns.push({
            text: profileName,
            dataField: profileName,
            sort: true,
            style: (cell) => {
               const backgroundColor = getHeatMapColors(cell, maxValue, 0.5, true);
               return {
                  verticalAlign: 'middle',
                  textAlign: 'center',
                  backgroundColor,
               };
            },
            headerAlign: 'center',
            formatter: (cell) => showOverflowTooltip(formatters[0](cell)),
         });
      });
   }

   return columns;
}

function isOrgaColumnRequired(tableData) {
   if (tableData === undefined || tableData.length === 0) {
      return false;
   }
   if (tableData[0]['orga']) {
      return true;
   }
   return false;
}
